import { useLocation } from 'react-router-dom';
import { isHiddenPath } from '../constants';

export const useBarRouteVisibility = (): boolean => {
  const { pathname } = useLocation();
  return !isHiddenPath(pathname);
};
